import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { addAllList } from 'modules/common';
import { openRtbCategory } from 'lib/api/code';
import { showSuccessSnackbar } from 'modules/snackbar';

import FilterCollection from 'components/organisms/FilterCollection';

const OpenRTBSizeBox = (props) => {
  const { getParams, params, getList } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    openRtbCategory()
      .then((response) => {
        let newList = [];
        for (let size of response.data.data) {
          newList.push({ label: size['CTGR_NM'], value: size['CTGR_SEQ'] });
        }
        setCategoryList(newList);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      }); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (typeof getList !== 'undefined') {
      getList(categoryList);
    }
    // eslint-disable-next-line
  }, [categoryList]);

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    !!categoryList.length && (
      <FilterCollection
        label={t('카테고리')}
        value={params.ctgrSeq}
        name="ctgrSeq"
        type="select"
        params={params}
        list={addAllList(categoryList, 'label', 'value', 'all')}
        labelKey="label"
        valueKey="value"
        callBack={getParams}
      />
    )
  );
};

export default OpenRTBSizeBox;
